(function () {
  'use strict';

  // CC Text Fields -- NEW CODE, no Atelier counterpart. See
  // snippets/cc-block-text-fields.liquid for the config schema.
  //
  // N independent one-line inputs, each posting its OWN properties[...] key.
  // Nothing is joined here, so this block never calls window.ccJoin -- the
  // shared separator only governs multi-VALUE properties, and every field
  // here is single-valued.

  var root = document.querySelector('[data-cc-text-fields]');
  if (!root) return;

  var fields = [].slice.call(root.querySelectorAll('[data-cc-text-field]'));
  if (!fields.length) return;

  function readField(el) {
    var input = el.querySelector('[data-cc-text-field-input]');
    // Whitespace-only never satisfies a required gate -- a space is not an
    // engraving. The VALUE still posts as typed; only the gate trims.
    var filled = input && String(input.value).trim() !== '' ? 1 : 0;
    return {
      property: el.dataset.property || el.dataset.label || '',
      label: el.dataset.label || '',
      required: el.hasAttribute('data-required'),
      filled: filled
    };
  }

  // A blank field posts NO key rather than an empty string, matching the
  // gift/Diamond toggles, designer notes and text_engraving. Applies to required
  // entries too: while one is blank the gate holds add-to-cart shut, so the
  // only state in which a required key could be missing is one the shopper
  // cannot submit from.
  //
  // window.ccSubmitWhenFilled (cc-join.js) is the ONE implementation of that
  // suppression — it gates by form ownership, never by touching the name
  // attribute, which would break Pipeline's cached serialiser and freeze the
  // variant id. Each entry owns its own properties[...] input.
  function syncPropertyName(el) {
    window.ccSubmitWhenFilled(el.querySelector('[data-cc-text-field-input]'));
  }

  function updateCounter(el) {
    var input = el.querySelector('[data-cc-text-field-input]');
    var counter = el.querySelector('[data-cc-counter]');
    if (!input || !counter) return;
    var max = parseInt(el.dataset.maxChars, 10) || 50;
    var len = input.value.length;
    counter.hidden = len === 0;
    counter.textContent = len + '/' + max + ' characters';
    counter.classList.toggle('is-warning', len > max * 0.8 && len < max);
    counter.classList.toggle('is-full', len >= max);
  }

  // One aggregated event for the whole block rather than one per field: the
  // gate cares about "are all required fields filled", and a per-field event
  // would make the bridge reassemble that state itself.
  function emit() {
    var states = fields.map(readField);
    var requiredTotal = 0;
    var requiredFilled = 0;
    states.forEach(function (s) {
      if (!s.required) return;
      requiredTotal++;
      if (s.filled) requiredFilled++;
    });

    document.dispatchEvent(new CustomEvent('cc:textfields-changed', {
      detail: {
        fields: states,
        requiredTotal: requiredTotal,
        requiredFilled: requiredFilled,
        complete: requiredFilled >= requiredTotal
      }
    }));
  }

  fields.forEach(function (el) {
    var input = el.querySelector('[data-cc-text-field-input]');
    if (!input) return;
    input.addEventListener('input', function () {
      updateCounter(el);
      syncPropertyName(el);
      emit();
    });
    updateCounter(el);
    syncPropertyName(el);
  });

  // Fire once on init so the gate is seeded before any interaction.
  emit();
})();
